import { render, staticRenderFns } from "./SettingFootWay.vue?vue&type=template&id=716e248a&scoped=true&"
import script from "./SettingFootWay.vue?vue&type=script&lang=js&"
export * from "./SettingFootWay.vue?vue&type=script&lang=js&"
import style0 from "./SettingFootWay.vue?vue&type=style&index=0&id=716e248a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e248a",
  null
  
)

export default component.exports